import {AppState} from "@crm/services/store";

export function selectWindowCleaningPage(state: AppState) {
    return state.windowCleaning.currentPage;
}

export function selectWindowCleaningMaxPage(state: AppState) {
    return state.windowCleaning.maxPage;
}

export function selectWindowCleaningPriceExpanded(state: AppState) {
    return state.windowCleaning.priceExpanded;
}

export function selectWindowCleaningServiceTypeId(state: AppState) {
    return state.windowCleaning.serviceTypeId;
}

export function selectWindowCleaningAddress(state: AppState) {
    return state.windowCleaning.address;
}

export function selectWindowCleaningWindows(state: AppState) {
    return state.windowCleaning.windows;
}

export function selectWindowCleaningResidenceType(state: AppState) {
    return state.windowCleaning.residenceType;
}

export function selectWindowCleaningServiceId(state: AppState) {
    return state.windowCleaning.serviceId;
}

export function selectWindowCleaningSecondaryGlazing(state: AppState) {
    return state.windowCleaning.secondaryGlazing;
}

export function selectWindowCleaningFrequencyId(state: AppState) {
    return state.windowCleaning.frequencyId;
}

export function selectWindowCleaningAvailability(state: AppState) {
    return state.windowCleaning.availability;
}

export function selectWindowCleaningAvailabilityFetchTime(state: AppState) {
    return state.windowCleaning.availabilityFetched;
}

export function selectWindowCleaningAuthenticated(state: AppState) {
    return state.windowCleaning.authenticated;
}

export function selectWindowCleaningPaymentType(state: AppState) {
    return state.windowCleaning.paymentType;
}

export function selectWindowCleaningVerifiedCode(state: AppState) {
    return state.windowCleaning.verifiedCode;
}

export function selectWindowCleaningUnverifiedCode(state: AppState) {
    return state.windowCleaning.unverifiedCode;
}

export function selectWindowCleaningGeneralNote(state: AppState) {
    return state.windowCleaning.generalNote;
}

export function selectWindowCleaningCompleted(state: AppState) {
    return state.windowCleaning.completed;
}

export function selectWindowCleaning(state: AppState) {
    return state.windowCleaning;
}
